import React from 'react';

import { FilterSelect, Filters } from 'filters';
import {
  FILTER_ACTION_TYPE,
  FILTER_ADDED,
  FILTER_AFFILIATES,
  FILTER_APPLICATIONS,
  FILTER_BUSINESS_PARTNERS,
  FILTER_CREATED_BY,
  FILTER_PERIOD,
  FILTER_STATUSES,
  FILTER_TYPES,
} from 'scenes/FinancePage/constants';
import { loadActionTypes } from 'scenes/FinancePage/sources/filters/loadActionTypes';
import { loadAdded } from 'scenes/FinancePage/sources/filters/loadAdded';
import { loadAffiliates } from 'scenes/FinancePage/sources/filters/loadAffiliates';
import { loadApplications } from 'scenes/FinancePage/sources/filters/loadApplications';
import { loadBusinessPartners } from 'scenes/FinancePage/sources/filters/loadBusinessPartners';
import { loadCreatedBy } from 'scenes/FinancePage/sources/filters/loadCreatedBy';
import { loadPeriods } from 'scenes/FinancePage/sources/filters/loadPeriods';
import { loadStatuses } from 'scenes/FinancePage/sources/filters/loadStatuses';
import { loadTypes } from 'scenes/FinancePage/sources/filters/loadTypes';

import './index.css';

const DEPENDENCIES = {
  [FILTER_ACTION_TYPE]: [],
  [FILTER_TYPES]: [],
  [FILTER_PERIOD]: [],
  [FILTER_ADDED]: [],
  [FILTER_CREATED_BY]: [],
  [FILTER_APPLICATIONS]: [],
  [FILTER_STATUSES]: [],
  [FILTER_AFFILIATES]: [FILTER_BUSINESS_PARTNERS],
  [FILTER_BUSINESS_PARTNERS]: [],
};

const FiltersModal = ({
  initialValues = {},
  defaultValues = {},
  onSubmit,
  onClose,
}: any) => {
  return (
    <Filters
      initialValues={initialValues}
      defaultValues={defaultValues}
      onSubmit={onSubmit}
      onClose={onClose}
    >
      <FilterSelect
        label={'Show'}
        name={FILTER_ACTION_TYPE}
        source={loadActionTypes}
        depends={DEPENDENCIES[FILTER_ACTION_TYPE]}
        clearableBlock={true}
      />
      <FilterSelect
        label={'Added'}
        name={FILTER_ADDED}
        source={loadAdded}
        depends={DEPENDENCIES[FILTER_ADDED]}
        clearable={true}
      />
      <FilterSelect
        label={'Types'}
        name={FILTER_TYPES}
        source={loadTypes}
        depends={DEPENDENCIES[FILTER_TYPES]}
        multiple={true}
        clearable={true}
      />
      <FilterSelect
        label={'Period'}
        name={FILTER_PERIOD}
        source={loadPeriods}
        depends={DEPENDENCIES[FILTER_PERIOD]}
        clearableBlock={true}
      />
      <FilterSelect
        label={'Created by'}
        name={FILTER_CREATED_BY}
        source={loadCreatedBy}
        depends={DEPENDENCIES[FILTER_CREATED_BY]}
        multiple={true}
        clearable={true}
      />
      <FilterSelect
        label={'Applications'}
        name={FILTER_APPLICATIONS}
        source={loadApplications}
        depends={DEPENDENCIES[FILTER_APPLICATIONS]}
        multiple={true}
        clearable={true}
      />
      <FilterSelect
        label={'Statuses'}
        name={FILTER_STATUSES}
        source={loadStatuses}
        depends={DEPENDENCIES[FILTER_STATUSES]}
        multiple={true}
        clearable={true}
      />
      <FilterSelect
        label={'Business Partners'}
        name={FILTER_BUSINESS_PARTNERS}
        source={loadBusinessPartners}
        depends={DEPENDENCIES[FILTER_BUSINESS_PARTNERS]}
        multiple={true}
        clearable={true}
      />
      <FilterSelect
        label={'Affiliates'}
        name={FILTER_AFFILIATES}
        source={loadAffiliates}
        depends={DEPENDENCIES[FILTER_AFFILIATES]}
        multiple={true}
        clearable={true}
      />
    </Filters>
  );
};

export default FiltersModal;
